<template>
  <el-drawer
    v-if="properties"
    size="550px"
    class="drawer"
    :visible.sync="visible"
    :show-close="false"
    style="text-align:left;"
    @close="cancel"
  >
    <!-- 标题 -->
    <header
      v-if="
        value &&
          (value.type == 'start' || value.type === 'copy') &&
          properties.title
      "
      slot="title"
      class="header"
    >
      {{ properties.title }}
    </header>
    <header v-else slot="title" class="header">
      <span
        v-if="isAutoAudit()"
        v-show="!titleInputVisible"
        style="cursor:pointer;"
        @click="titleInputVisible = true"
      >
        {{ properties.title }}
        <i class="el-icon-edit"></i>
      </span>
      <span v-else>
        {{ properties.title }}
      </span>
      <el-input
        v-show="titleInputVisible"
        v-model="properties.title"
        v-clickoutside="_ => (titleInputVisible = false)"
        size="mini"
        style="z-index:9;max-width: 200px;"
      ></el-input>
      <el-select
        v-if="isConditionNode()"
        v-model="properties.priority"
        size="mini"
        class="priority-select"
      >
        <el-option
          v-for="item in priorityLength"
          :key="item"
          :value="item - 1"
          :label="'优先级' + item"
        ></el-option>
      </el-select>
    </header>

    <!-- 条件  -->
    <!-- <section
      v-if="value && isConditionNode()"
      class="approver-pane"
      style="display: none;"
    >
      <row-wrapper v-if="showingPCons.includes(-1)" title="发起人">
        <fc-org-select
          ref="condition-org"
          v-model="initiator"
          :tabList="['dep&user']"
        />
      </row-wrapper>

      <template v-for="(item, index) in pconditions">
        <row-wrapper
          v-if="
            couldShowIt(
              item,
              'el-input-number',
              'fc-date-duration',
              'fc-time-duration',
              'fc-amount',
              'fc-calculate'
            )
          "
          :key="index"
          :title="item.label"
        >
          <num-input
            :key="index"
            v-model="item.conditionValue"
            :title="timeTangeLabel(item)"
            style="padding-right: 6px;"
          ></num-input>
          <template #action>
            <i
              class="el-icon-delete"
              style="cursor: pointer;"
              @click="onDelCondition(item)"
            ></i>
          </template>
        </row-wrapper>
        <row-wrapper
          v-if="couldShowIt(item, 'el-radio-group')"
          :key="index"
          :title="item.label"
        >
          <el-radio-group v-model="item.conditionValue" class="radio-group">
            <el-radio
              v-for="e in item.options"
              :key="e.label"
              :label="e.label"
              >{{ e.label }}</el-radio
            >
          </el-radio-group>
          <template #action>
            <i
              class="el-icon-delete"
              style="cursor: pointer;"
              @click="onDelCondition(item)"
            ></i>
          </template>
        </row-wrapper>

        <row-wrapper
          v-if="couldShowIt(item, 'el-select')"
          :key="index"
          :title="item.label"
        >
          <el-select
            v-model="item.conditionValue"
            placeholder="请选择"
            size="small"
          >
            <el-option
              v-for="e in item.options"
              :key="e.value"
              :label="e.label"
              :value="e.value"
            ></el-option>
          </el-select>
          <template #action>
            <i
              class="el-icon-delete"
              style="cursor: pointer;"
              @click="onDelCondition(item)"
            ></i>
          </template>
        </row-wrapper>
        <row-wrapper
          v-if="couldShowIt(item, 'fc-org-select')"
          :key="index"
          :title="item.label"
        >
          <fc-org-select
            :ref="'org' + index"
            v-model="item.conditionValue"
            :tabList="['dep']"
          />
          <template #action>
            <i
              class="el-icon-delete"
              style="cursor: pointer;"
              @click="onDelCondition(item)"
            ></i>
          </template>
        </row-wrapper>
      </template>
      <div style="padding-left:10px;margin-top:2em;">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="dialogVisible = true"
          >添加条件</el-button
        >
        <span style="color:#aaa;margin-left:16px;"
          >还有{{ notUseConNum }}个可用条件</span
        >
      </div>
    </section> -->

    <!-- 审批人 -->
    <section
      v-if="value && (isApproverNode() || isStartNode() || isConditionNode())"
      class="approver-pane"
      style="height:100%;"
    >
      <el-tabs v-model="activeName" type="border-card" class="pane-tab">
        <el-tab-pane
          :label="'设置' + (value.type === 'start' ? '发起人' : '审批人')"
          name="config"
        >
          <!-- 开始节点 -->
          <el-row v-if="value.type === 'start'" style="padding: 10px;">
            <el-col :span="4" style="font-size: 12px;">发起人</el-col>
            <el-col :span="18" style="padding-left: 12px;">
              <fc-org-select
                ref="start-org"
                v-model="initiator"
                type="dep&user"
                title="发起人"
              />
            </el-col>
          </el-row>

          <div v-else>
            <el-form label-position="top">
              <el-form-item
                v-if="workConfig.isAdminFlag"
                label="允许添加下级"
                required
              >
                <el-radio-group v-model="approverForm.downAddFlag">
                  <el-radio :label="1" class="radio-item">是</el-radio>
                  <el-radio :label="0" class="radio-item">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="isAutoAudit()" label="审批人类型" required>
                <el-radio-group
                  v-model="approverForm.assigneeType"
                  @change="resetOrgColl"
                >
                  <el-radio
                    v-for="item in assigneeTypeOptions"
                    :key="item.value"
                    :label="item.value"
                    class="radio-item"
                    >指定{{ item.label }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item>
                <fc-org-select
                  ref="approver-org"
                  v-model="orgCollection"
                  buttonType="button"
                  :companyList="companyList"
                  :title="getAssignTypeLabel()"
                  :type="
                    fcOrgTabList.includes(approverForm.assigneeType)
                      ? approverForm.assigneeType
                      : 'role'
                  "
                  @change="onOrgChange"
                />
              </el-form-item>

              <el-form-item
                v-if="isAutoAudit()"
                label="多人审批时采用的审批方式"
                required
              >
                <template v-if="['user'].includes(approverForm.assigneeType)">
                  <el-radio
                    v-model="approverForm.auditMode"
                    :label="1"
                    class="radio-item"
                    >依次审批</el-radio
                  >
                  <br />
                  <el-radio
                    v-model="approverForm.auditMode"
                    :label="2"
                    class="radio-item"
                    >会签（须所有审批人同意）</el-radio
                  >
                  <br />
                </template>
                <el-radio
                  v-model="approverForm.auditMode"
                  :label="3"
                  class="radio-item"
                  >或签（一名审批人同意或拒绝即可）</el-radio
                >
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="表单权限" name="formAuth">
          <div class="form-auth-table">
            <header class="auth-table-header">
              <div class="row">
                <div class="label">表单字段</div>
                <el-radio-group
                  v-model="globalFormOperate"
                  class="radio-group"
                  @change="changeAllFormOperate"
                >
                  <el-radio :label="2" style="margin-left: 1rem;"
                    >可编辑</el-radio
                  >
                  <el-radio :label="1">只读</el-radio>
                  <el-radio :label="0">隐藏</el-radio>
                </el-radio-group>
              </div>
            </header>
            <div class="auth-table-body">
              <div
                v-for="item in isStartNode()
                  ? startForm.formOperates
                  : approverForm.formOperates"
                :key="item.formId"
                class="row"
              >
                <div class="label">
                  <span v-show="item.required" class="required">*</span>
                  {{ item.label }}
                </div>
                <el-radio-group v-model="item.formOperate" class="radio-group">
                  <el-radio :label="2" style="margin-left: 1rem;"
                    ><span style="opacity: 0;">可编辑</span></el-radio
                  >
                  <el-radio :label="1"
                    ><span style="opacity: 0;">只读</span></el-radio
                  >
                  <el-radio :label="0"
                    ><span style="opacity: 0;">隐藏</span></el-radio
                  >
                </el-radio-group>
              </div>
            </div>
          </div>
        </el-tab-pane> -->
        <el-tab-pane
          v-if="isApproverNode() && isAutoAudit()"
          label="设置审批样式"
          name="formStyle"
        >
          <el-form label-position="top">
            <el-form-item label="审批样式类型">
              <el-radio-group
                v-model="approverForm.auditStyleType"
                @change="changeAuditStyleType"
              >
                <el-radio :label="1">默认审批样式</el-radio>
                <el-radio :label="2">自定义审批样式</el-radio>
                <el-radio v-if="workConfig.isAdminFlag" :label="3"
                  >自动审批</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-form>
          <div v-if="approverForm.auditStyleType === 1" class="approver-style">
            <el-form label-width="100px">
              <el-form-item label="审批结果" required>
                <el-row>
                  <el-col :span="20">
                    <el-radio-group
                      v-model="approverForm.formStyle.flag"
                      disabled
                    >
                      <el-radio :label="1">通过</el-radio>
                      <el-radio :label="2">驳回</el-radio>
                    </el-radio-group>
                  </el-col>
                  <el-col :span="4"></el-col>
                </el-row>
              </el-form-item>
              <el-form-item
                label="审批意见"
                :required="approverForm.formStyle.remarkChecked"
              >
                <div style="padding: 0 5px;">
                  <el-row :gutter="10">
                    <el-col :span="20">
                      <el-input
                        v-model="approverForm.formStyle.remark"
                        type="textarea"
                        :rows="4"
                        :maxlength="200"
                        disabled
                      ></el-input>
                    </el-col>
                    <el-col :span="4">
                      <el-checkbox
                        v-model="approverForm.formStyle.remarkChecked"
                      >
                        必填
                      </el-checkbox>
                    </el-col>
                  </el-row>
                </div>
              </el-form-item>
              <el-form-item
                label="附件"
                :required="approverForm.formStyle.fileIdsChecked"
              >
                <div style="padding: 0 5px;">
                  <el-row :gutter="10">
                    <el-col :span="20">
                      <el-button type="primary" size="small" disabled>
                        点击上传
                      </el-button>
                    </el-col>
                    <el-col :span="4">
                      <el-checkbox
                        v-model="approverForm.formStyle.fileIdsChecked"
                      >
                        必填
                      </el-checkbox>
                    </el-col>
                  </el-row>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div v-if="approverForm.auditStyleType === 2" class="approver-style">
            <el-tabs v-model="approverForm.flag" @tab-click="changeFlag">
              <el-tab-pane label="选择已有审批样式" name="1"></el-tab-pane>
              <el-tab-pane label="新建审批样式" name="2"></el-tab-pane>
            </el-tabs>
            <el-form label-position="top">
              <el-form-item
                v-if="approverForm.flag === '1'"
                label="选择已有审批样式"
                required
              >
                <el-select
                  v-if="
                    !approverForm.auditStyleId ||
                      (approverForm.auditStyleId &&
                        !approverForm.auditStyleName) ||
                      isAuditStyle
                  "
                  v-model="approverForm.auditStyleId"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, i) in auditStyleList"
                    :key="i"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <div v-else class="audit-style-item">
                  <span
                    class="audit-style-title"
                    v-text="approverForm.auditStyleName"
                  ></span>
                  <el-button
                    type="danger"
                    size="mini"
                    @click="deleteAuditStyle(approverForm)"
                    >删除</el-button
                  >
                  <el-button
                    type="primary"
                    size="mini"
                    @click="addAuditStyleVisible = true"
                    >修改</el-button
                  >
                </div>
              </el-form-item>
              <el-form-item v-else label="新建审批样式" required>
                <el-button
                  v-if="!approverForm.auditStyleId"
                  type="primary"
                  icon="el-icon-plus"
                  @click="addAuditStyleModal()"
                >
                  新建
                </el-button>
                <div v-else class="audit-style-item">
                  <span
                    class="audit-style-title"
                    v-text="approverForm.auditStyleName"
                  ></span>
                  <el-button
                    type="danger"
                    size="mini"
                    @click="deleteAuditStyle(approverForm)"
                    >删除</el-button
                  >
                  <el-button
                    type="primary"
                    size="mini"
                    @click="addAuditStyleVisible = true"
                    >修改</el-button
                  >
                </div>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </section>

    <el-dialog
      :title="approverForm.auditStyleId ? '编辑审批样式' : '新建审批样式'"
      class="cus-dialog-container"
      :visible.sync="addAuditStyleVisible"
      append-to-body
      fullscreen
    >
      <el-form
        ref="addAuditStyleRef"
        :model="addAuditStyleFormData"
        :rules="addAuditStyleFormRules"
        label-width="150px"
      >
        <el-form-item label="审批样式名称" prop="name">
          <el-input
            v-model="addAuditStyleFormData.name"
            placeholder="请录入审批样式名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <DynamicForm
        v-if="addAuditStyleVisible"
        ref="auditFormDesignRef"
        :workConfig="workConfig"
        :isFlagDelete="false"
        :formId="approverForm.auditStyleId"
        isApprover
      />
      <div slot="footer" class="dialog-footer">
        <el-button plain @click="addAuditStyleVisible = false">取消</el-button>
        <el-button
          type="primary"
          :disabled="!addAuditStyleFormData.name"
          :loading="addAuditStyleBtnLoading"
          @click="saveAuditStyle(2)"
          >提交</el-button
        >
        <el-button
          type="primary"
          :disabled="!addAuditStyleFormData.name"
          :loading="addAuditStyleBtnCommonLoading"
          @click="saveAuditStyle(1)"
          >提交并添加到审批样式库</el-button
        >
      </div>
    </el-dialog>

    <section
      v-if="value && isCopyNode()"
      class="approver-pane"
      style="padding-left: 1rem;"
    >
      <el-form label-position="top">
        <el-form-item label="抄送人类型" required>
          <el-radio-group
            v-model="properties.assigneeType"
            @change="resetOrgCollCopy"
          >
            <el-radio
              v-for="item in assigneeTypeOptions"
              :key="item.value"
              :label="item.value"
              class="radio-item"
              >指定{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <fc-org-select
          ref="copy-org"
          v-model="properties.menbers"
          :companyList="companyList"
          buttonType="button"
          :type="
            fcOrgTabList.includes(properties.assigneeType)
              ? properties.assigneeType
              : 'role'
          "
          title="抄送人"
        />
        <el-form-item> </el-form-item>
      </el-form>
      <!-- <el-checkbox v-model="properties.userOptional">
        允许发起人自选抄送人
      </el-checkbox> -->
    </section>

    <el-dialog
      title="选择条件"
      :visible.sync="dialogVisible"
      width="500px"
      :append-to-body="true"
      custom-class="condition-dialog"
    >
      <el-checkbox-group v-model="showingPCons">
        <!-- 发起人默认就有 -->
        <el-checkbox :label="-1">发起人</el-checkbox>
        <el-checkbox
          v-for="(item, index) in pconditions"
          :key="index"
          :label="item.formId"
        >
          {{ item.label }}
        </el-checkbox>
      </el-checkbox-group>
    </el-dialog>

    <div class="actions">
      <el-button size="medium" @click="cancel">取消</el-button>
      <el-button size="medium" type="primary" @click="confirm">确定</el-button>
    </div>
  </el-drawer>
</template>
<script>
import Clickoutside from "element-ui/src/utils/clickoutside";
import { NodeUtils } from "../FlowCard/util.js";
// import RowWrapper from "./RowWrapper";
import DynamicForm from "@/components/DynamicForm";
const rangeType = {
  lt: "<",
  lte: "≤",
  gt: ">",
  gte: "≥",
  eq: "="
};
const defaultApproverForm = {
  approvers: [], // 审批人集合
  assigneeType: "user", // 指定审批人
  formOperates: [], // 表单操作权限集合
  // 审批类型为自选 出现 optionalMultiUser optionalRange
  optionalMultiUser: true,
  downAddFlag: 1,
  optionalRange: "ALL", // USER<最多十个> / ALL / ROLE
  auditStyleType: 1, // 审批样式类型(1:默认审批样式,2:自定义审批样式)
  auditStyleId: "", // 审批样式id
  auditStyleName: "", // 审批样式名称
  auditMode: 3, // 审批方式(1:依次审批,2:会签,3:或签)
  flag: "1", // 审批样式标识(1:选择已有审批样式,2:新建审批样式)
  formStyle: {
    status: 0, //默认审批样式
    flag: 1,
    remark: "",
    remarkChecked: false,
    fileIds: "",
    fileIdsChecked: false,
    selectStyle: ""
  }
};
export default {
  directives: {
    Clickoutside
  },
  components: {
    // "row-wrapper": RowWrapper,
    DynamicForm
  },
  props: [
    /*当前节点数据*/ "value",
    /*整个节点数据*/ "processData",
    "companyList",
    "workConfig"
  ],
  data() {
    return {
      fcOrgTabList: ["dep", "role", "user", "position"],
      visible: false, // 控制面板显隐
      globalFormOperate: null, // 统一设置节点表单权限
      titleInputVisible: false, // 是否显示标题输入框  startNode 不显示
      activeName: "config", // or formAuth  Tab面板key
      showingPCons: [], // 用户选择了得条件  被选中的才会被展示在面板上编辑
      pconditions: [], // 从vuex中获取的可以作为流程图条件的集合
      dialogVisible: false, // 控制流程条件选项Dialog显隐
      // 当前节点数据
      properties: {},
      // 发起人  start节点和condition节点需要
      initiator: [],
      priorityLength: 0, // 当为条件节点时  显示节点优先级选项的数据
      orgCollection: [],
      useDirectorProxy: true, // 找不到主管时 上级主管代理审批
      directorLevel: 1, // 审批主管级别
      startForm: {
        formOperates: []
      },
      approverForm: JSON.parse(JSON.stringify(defaultApproverForm)),

      optionalOptions: [
        {
          label: "自选一个人",
          value: false
        },
        {
          label: "自选多个人",
          value: true
        }
      ],
      rangeOptions: [
        {
          label: "全公司",
          value: "ALL"
        },
        {
          label: "成员",
          value: "USER"
        },
        {
          label: "角色",
          value: "ROLE"
        }
      ],
      auditStyleList: [],
      addAuditStyleVisible: false,
      addAuditStyleFormData: {
        id: "",
        name: "",
        template: "",
        type: 2
      },
      addAuditStyleFormDataBack: {},
      addAuditStyleBtnLoading: false,
      addAuditStyleBtnCommonLoading: false,
      addAuditStyleFormRules: {
        name: [
          {
            required: true,
            message: "请输入审批样式名称",
            trigger: "blur"
          }
        ]
      },
      isAuditStyle: false
    };
  },
  computed: {
    assigneeTypeOptions() {
      if (this.workConfig.isSingleCompany) {
        return [
          {
            label: "成员",
            value: "user"
          }
        ];
      } else {
        return [
          {
            label: "成员",
            value: "user"
          },
          {
            label: "角色",
            value: "role"
          }
        ];
      }
    },
    // 未使用的条件个数
    notUseConNum() {
      // 发起人是默认就有得  所以需要加 1
      return this.pconditions.length - this.showingPCons.length + 1;
    },
    formParams() {
      return {
        token: this.workConfig.token,
        projectType: this.workConfig.projectType,
        projectId: this.workConfig.projectId
      };
    }
  },
  watch: {
    visible(val) {
      if (!val) {
        this.activeName = "config";
        this.approverForm = JSON.parse(JSON.stringify(defaultApproverForm)); // 重置数据为默认状态
        return;
      }
      this.processData.properties.formOperates = this.initFormOperates(
        this.processData
      ).map(t => ({ formId: t.formId, formOperate: t.formOperate }));
      this.isStartNode() && this.initStartNodeData();
      this.isApproverNode() && this.initApproverNodeData();
      this.isConditionNode() && this.initApproverNodeData(); // this.initConditionNodeData()
      this.addAuditStyleFormData.name = this.approverForm.auditStyleName;
      this.addAuditStyleFormData.id = this.approverForm.auditStyleId;
      this.getAuditStyle();
    },

    value(newVal) {
      if (newVal && newVal.properties) {
        this.visible = true;
        // console.log("2222222-------", newVal.properties);
        this.properties = JSON.parse(JSON.stringify(newVal.properties));
        if (this.properties) {
          NodeUtils.isConditionNode(newVal) && this.getPriorityLength();
        }
      }
    }
  },
  mounted() {
    Object.assign(this.addAuditStyleFormDataBack, this.addAuditStyleFormData);
  },
  methods: {
    // 判断是否是自动审批
    isAutoAudit() {
      let status = true;
      if (
        !this.workConfig.isAdminFlag &&
        this.approverForm.auditStyleType === 3
      ) {
        status = false;
      }
      return status;
    },
    // 审批样式类型改变
    changeAuditStyleType() {
      this.approverForm.auditStyleId = "";
      this.approverForm.auditStyleName = "";
    },
    // 审批样式改变
    changeFlag() {
      if (this.approverForm.flag === "2") {
        this.changeAuditStyleType();
      }
    },
    // 新建审批样式
    addAuditStyleModal() {
      this.addAuditStyleVisible = true;
      Object.assign(this.addAuditStyleFormData, this.addAuditStyleFormDataBack);
    },
    // 审批样式下拉列表
    async getAuditStyle() {
      let result = await this.$axios.get(
        this.workConfig.configApi.getAuditStyle,
        this.formParams
      );
      let datas = result.data || [];
      let list = [];
      datas.map(item => {
        list.push({
          id: item.id,
          name: item.name,
          label: item.name,
          value: item.id
        });
        if (this.approverForm.auditStyleId === item.id) {
          this.isAuditStyle = true;
        }
      });
      this.auditStyleList = list;
    },
    // 查询表单数据
    async saveAuditStyle(type) {
      let result = await this.$refs.auditFormDesignRef.getData();
      let datas = result.formData;
      let params = {};
      this.addAuditStyleFormData.template = JSON.stringify(datas);
      this.addAuditStyleFormData.type = type;
      this.$refs["addAuditStyleRef"].validate(valid => {
        if (valid) {
          if (datas.list.length === 0) {
            this.$message({
              type: "error",
              message: "表单内容不能为空!"
            });
            return;
          }
          if (!_.map(datas.list, "el").includes("flag")) {
            this.$message({
              type: "error",
              message: "表单内容缺少审批结果!"
            });
            return;
          }
          this.saveAuditStyleSuccess(type);
        }
      });
    },
    // 删除审批样式
    deleteAuditStyle(item) {
      console.log("删除审批样式", item);
      let id = item.auditStyleId;
      this.$confirm("确定要删除审批样式?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          if (!this.approverForm.auditStyleName) {
            this.deleteSuccess();
            return;
          }
          await this.$axios.get(
            this.workConfig.configApi.deleteAuditStyle + id,
            this.formParams
          );
          this.deleteSuccess();
        })
        .catch(() => {});
    },
    // 删除成功
    deleteSuccess() {
      this.$message({
        type: "success",
        message: "删除成功!"
      });
      this.approverForm.auditStyleId = "";
      this.approverForm.auditStyleName = "";
    },
    // 保存审批样式
    async saveAuditStyleSuccess(type) {
      let params = Object.assign(
        {},
        this.formParams,
        this.addAuditStyleFormData
      );
      try {
        if (type === 1) {
          this.addAuditStyleBtnCommonLoading = true;
        } else {
          this.addAuditStyleBtnLoading = true;
        }

        let result = await this.$axios.post(
          this.workConfig.configApi.saveAuditStyle,
          params
        );
        let datas = result.data;
        this.$message({
          type: "success",
          message: "保存成功!"
        });
        this.approverForm.auditStyleId = datas.id;
        this.approverForm.auditStyleName = datas.name;
        this.addAuditStyleBtnLoading = false;
        this.addAuditStyleBtnCommonLoading = false;
        this.addAuditStyleVisible = false;
      } catch (e) {
        this.addAuditStyleBtnLoading = false;
        this.addAuditStyleBtnCommonLoading = false;
      }
    },
    getFormOperates() {
      let res = [];
      this.isApproverNode() && (res = this.approverForm.formOperates);
      this.isStartNode() && (res = this.startForm.formOperates);
      return res;
    },
    resetOrgColl() {
      this.orgCollection = [];
    },
    resetOrgCollCopy() {
      this.properties.menbers = [];
    },
    onOrgChange(data) {},
    timeTangeLabel(item) {
      const index = ["fc-time-duration", "fc-date-duration"].findIndex(
        t => t === item.tag
      );
      if (index > -1) {
        return "时长" + ["(小时)", "(天)"][index];
      } else {
        return item.label;
      }
    },
    getAssignTypeLabel() {
      const res = this.assigneeTypeOptions.find(
        t => t.value === this.approverForm.assigneeType
      );
      return res ? res.label : "";
    },
    changeAllFormOperate(val) {
      const target = this.isStartNode() ? this.startForm : this.approverForm;
      // console.log("操作权限 0 隐藏 1 只读 2 可编辑", val, target);
      target.formOperates.map(t => (t.formOperate = val));
      // this.getFormOperates();
    },
    // 是否可以显示当前条件组件
    couldShowIt(item, ...tag) {
      return tag.includes(item.tag) && this.showingPCons.includes(item.formId);
    },

    initFormOperates(target) {
      // console.log("initFormOperates", target);
      const formOperates =
        (target.properties && target.properties.formOperates) || [];
      // 自定义组件不加入权限控制
      let res = _.cloneDeep(this.workConfig.formItemList);
      res.map((e, i) => {
        if (formOperates[i]) {
          e.formOperate = formOperates[i].formOperate;
        }
      });
      return res;
    },

    initCopyNode() {
      this.properties = this.value.properties;
    },

    initStartNodeData() {
      this.initInitiator();
      this.startForm.formOperates = this.initFormOperates(this.value);
    },

    /**
     * 条件节点确认保存得回调
     */
    conditionNodeComfirm() {
      let nodeContent = "";
      const conditions = [];
      this.showingPCons
        .map(fid => this.pconditions.find(t => t.formId === fid))
        .forEach(t => {
          if (!t) return; // 发起人条件时 t 为空 发起人在其他地方获取
          const cValue = t.conditionValue;
          if (cValue === undefined || cValue === null) {
            return;
          }
          const numberTypeCmp = [
            "el-input-number",
            "fc-date-duration",
            "fc-time-duration",
            "fc-amount",
            "fc-calculate"
          ];
          if (numberTypeCmp.includes(t.tag)) {
            if (cValue.type === "bet") {
              const numVal = cValue.value;
              nodeContent +=
                `[${numVal[0]} ${rangeType[numVal[1]]} ${t.label} ${
                  rangeType[numVal[2]]
                } ${numVal[3]}] ` + "\n";
            } else {
              nodeContent +=
                `[${t.label} ${rangeType[cValue.type]} ${cValue.value}] ` +
                "\n";
            }
          } else if (t.tag === "fc-org-select") {
            const index = this.pconditions.findIndex(
              p => p.formId === t.formId
            );
            const labels = this.$refs["org" + index][0].selectedLabels;
            nodeContent += `[${t.label} = ${labels}] ` + "\n";
          } else {
            nodeContent += `[${t.label} = ${cValue}] ` + "\n";
          }
          const res = { formId: t.formId, conditionValue: cValue };
          conditions.push(res);
        }, []);

      this.properties.conditions = conditions;
      // 发起人虽然是条件 但是这里把发起人放到外部单独判断
      this.properties.initiator = this.initiator;
      this.initiator &&
        (nodeContent =
          `[发起人: ${this.getOrgSelectLabel("condition")}]` +
          "\n" +
          nodeContent);
      this.$emit("confirm", this.properties, nodeContent || "请设置条件");
      this.visible = false;
    },

    getOrgSelectLabel(type) {
      console.log("getOrgSelectLabel", this.$refs[type + "-org"]);
      return this.$refs[type + "-org"]["selectedLabels"];
    },
    /**
     * 开始节点确认保存
     */
    startNodeComfirm() {
      this.properties.initiator = this.initiator;
      const formOperates = this.startForm.formOperates.map(t => ({
        formId: t.formId,
        formOperate: t.formOperate
      }));
      Object.assign(this.properties, { formOperates });
      this.$emit(
        "confirm",
        this.properties,
        this.getOrgSelectLabel("start") || "所有人"
      );
      this.visible = false;
    },
    /**
     * 审批节点确认保存
     */
    approverNodeComfirm() {
      const assigneeType = this.approverForm.assigneeType;
      let content = "";
      if (["optional", "myself"].includes(assigneeType)) {
        content = this.assigneeTypeOptions.find(t => t.value === assigneeType)
          .label;
      } else if ("director" === assigneeType) {
        content =
          this.directorLevel === 1
            ? "直接主管"
            : `第${this.directorLevel}级主管`;
      } else {
        console.log(3333);
        content = this.getOrgSelectLabel("approver");
      }
      const formOperates = this.approverForm.formOperates.map(t => ({
        formId: t.formId,
        formOperate: t.formOperate
      }));
      this.approverForm.approvers = this.orgCollection;
      Object.assign(this.properties, this.approverForm, { formOperates });

      // console.log(
      //   "保存---",
      //   this.properties.flag,
      //   this.properties.flag === "1",
      //   this.properties,
      //   content
      // );
      if (this.properties.auditStyleType === 1) {
        this.properties.flag = "1";
      }
      if (
        !this.properties.auditStyleId &&
        this.properties.auditStyleType === 2
      ) {
        let msg = this.properties.flag === "1" ? "选择" : "新建";
        this.$message({
          type: "error",
          message: `请${msg}审批样式!`
        });
        return;
      }
      this.$emit("confirm", this.properties, content || "请设置审批人");
      this.visible = false;
    },
    // 抄送人节点确认
    copyNodeConfirm() {
      const assigneeType = this.properties.assigneeType || "user";
      this.properties.assigneeType = assigneeType;
      // console.log("initCopyNode", this.properties, assigneeType);
      this.$emit(
        "confirm",
        this.properties,
        this.getOrgSelectLabel("copy") || "请设置抄送人"
      );
      this.visible = false;
    },
    // 确认修改
    confirm() {
      this.isCopyNode() && this.copyNodeConfirm();
      this.isStartNode() && this.startNodeComfirm();
      this.isApproverNode() && this.approverNodeComfirm();
      this.isConditionNode() && this.approverNodeComfirm(); // this.conditionNodeComfirm()
    },
    // 关闭抽屉
    cancel() {
      setTimeout(() => {
        this.$emit("cancel");
        this.visible = false;
      }, 0);
    },
    /**
     * 删除流程条件
     */
    onDelCondition(condition) {
      const index = this.showingPCons.findIndex(id => id === condition.formId);
      if (index > -1) {
        this.showingPCons.splice(index, 1);
        this.pconditions.find(
          t => t.formId === condition.formId
        ).conditionValue = undefined;
      }
    },
    // 配合getPriorityLength 获取前一个节点条件数组长度 用于设置优先级
    getPrevData() {
      return NodeUtils.getPreviousNode(this.value.prevId, this.processData);
    },
    // 用于获取节点优先级范围
    getPriorityLength() {
      this.priorityLength = this.getPrevData().conditionNodes.length;
    },
    // 判断是否是条件节点
    isConditionNode() {
      return this.value ? NodeUtils.isConditionNode(this.value) : false;
    },
    /** 判断是否是审批节点*/
    isApproverNode() {
      return this.value ? NodeUtils.isApproverNode(this.value) : false;
    },

    isStartNode() {
      return this.value ? NodeUtils.isStartNode(this.value) : false;
    },

    isCopyNode() {
      return this.value ? NodeUtils.isCopyNode(this.value) : false;
    },

    initInitiator() {
      const initiator =
        this.value.properties && this.value.properties.initiator;
      this.initiator = Array.isArray(initiator) ? initiator : [];
    },
    /**
     * 初始化审批节点所需数据
     */
    initApproverNodeData() {
      for (const key in this.approverForm) {
        if (this.value.properties.hasOwnProperty(key)) {
          this.approverForm[key] = this.value.properties[key];
        }
      }
      const approvers = this.approverForm.approvers;
      this.resetOrgColl();
      if (Array.isArray(this.approverForm.approvers)) {
        console.log(44444, approvers);
        this.orgCollection = approvers;
      }
      this.approverForm.formOperates = this.initFormOperates(this.value);
    },
    /**
     * 初始化条件节点数据
     */
    initConditionNodeData() {
      // 初始化条件表单数据
      let nodeConditions =
        this.value.properties && this.value.properties.conditions;
      this.pconditions = [];
      this.initiator = this.value.properties.initiator;
      if (Array.isArray(this.pconditions)) {
        let temp = undefined;
        this.showingPCons = [-1]; // 默认显示发起人
        this.pconditions.forEach(t => {
          if (Array.isArray(nodeConditions)) {
            const con = nodeConditions.find(item => item.formId === t.formId);
            con &&
              con.conditionValue &&
              ((temp = con.conditionValue), this.showingPCons.push(t.formId));
          }
          this.$set(t, "conditionValue", temp);
        });
      }
    }
  }
};
</script>
<style lang="less">
.condition-dialog {
  .el-dialog__header {
    border-bottom: 1px solid #eee;
  }
}
</style>
<style lang="less" scoped>
.approver-style {
  border: 1px #ddd solid;
  padding: 10px;
}
.drawer {
  > .el-drawer__header {
    margin-bottom: 0;
    border-bottom: 1px solid #c5c5c5;
    padding-bottom: 8px;
  }

  > .el-drawer__body {
    padding-bottom: 44px;
    overflow: hidden;
  }

  .pane-tab {
    height: 100%;
  }

  .pane-tab > .el-tabs__item.is-top:nth-child(2) {
    padding-left: 20px;
  }

  > .el-tabs__item:focus {
    box-shadow: none !important;
  }

  > .el-tabs__header {
    margin-bottom: 0;
  }
}

.header {
  line-height: 28px;
}

.actions {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 6px 12px;
  width: 100%;
  box-sizing: border-box;
  text-align: right;
}

.radio-item {
  width: 110px;
  padding: 6px;
}

.priority-select {
  width: 118px;
  position: absolute;
  right: 26px;
}

.form-auth-table {
  font-size: 14px;
  .auth-table-header {
    background: #fafafa;
    line-height: 40px;
  }
  .row {
    display: flex;
    align-items: center;
    line-height: 32px;
    padding: 8px 12px;
    border-bottom: 1px solid #efefef;
    &:hover {
      background: #f5f7fa;
    }
    .label {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      .required {
        color: #f2725e;
      }
    }
    .radio-group {
      flex: 2;
      display: flex;
      justify-content: space-between;
    }
  }
}

.approver-pane {
  overflow-y: auto;
  overflow-x: hidden;
  .option-box {
    font-size: 14px;
    padding-left: 1rem;
  }
}

.condition-pane {
  height: 100%;
  overflow: auto;
}
.audit-style-item {
  display: flex;
  padding: 0 10px;
  .audit-style-title {
    margin-right: 10px;
    flex: 1;
    line-height: 1;
  }
}
</style>
